import axios from 'axios';

const {REACT_APP_D_CORE_URL, REACT_APP_D_KEYCLOACK_URL} = process.env;

const keycloack_url = REACT_APP_D_KEYCLOACK_URL
const AppUrl = REACT_APP_D_CORE_URL


const get = async (url, data = {}, headers={"Content-Type": "application/json",'Authorization': `Bearer`}) => {
  return await request('GET', url, data, headers);
};

const put = async (url, data, headers={"Content-Type": "application/json",'Authorization': `Bearer`}) => {
  return await request('PUT', url, data, headers);
};

const post = async (url, data, headers= {"Content-Type": "application/json",'Authorization': `Bearer`}) => {
  return await request('POST', url, data, headers);
};

const destroy = async (url, data, headers={"Content-Type": "application/json",'Authorization': `Bearer`}) => {
  return await request('DELETE', url, data, headers);
};

const request = async (method, url, data,headers) => {
  const token = localStorage.getItem('Token')
  return await axios({
    headers : {
      // 'Authorization': `Bearer ${token}`
    },
    method,
    url: url === 'keycloack' ? keycloack_url: AppUrl+ url,
    data,
  });
};

export const DCore = {
  get,
  post,
  put,
  destroy,
  request
};